/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SimpleTimeWorkedCalculationRequest} from '@cash-web/protos/squareup/timecards/service.pb'
import {GetEmployeeTokensInCalculationResponse} from '@cash-web/protos/squareup/timecards/service.pb'


export const getEmployeeTokensInCalculation = (request: SimpleTimeWorkedCalculationRequest, options?: CashRequestOptions) => post<SimpleTimeWorkedCalculationRequest, GetEmployeeTokensInCalculationResponse>("/proxy/services/squareup.timecards.TimeCalculationService/GetEmployeeTokensInCalculation", request, {...options, rejectOnError: true })